module.exports = __webpack_public_path__ + "static/media/questionnaire-icon-default.dd4e17c0.svg";